<template>
    <b-overlay :show="submitting || updating || generalDeleting" rounded="sm">
    <div class="health-view">
        <div class="bg-white p-3 mt-3 activity-type-create col-12">
            <div class="d-flex title-bar-block mb-2">
                <div class="icon-block me-4">
                    <button v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                        <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2">{{ title }}</span>
                </div>
            </div>
                <b-form class="form-sample" @submit.stop.prevent="CreateOrUpdate">
                    <b-row>
                        <b-col cols="12">
                            <label class="mb-3"><strong>{{ $nameLabel() }}<span class="red">*</span> </strong></label>
                            <b-form-input type="text" id="input-name" v-custom-validation="$textRequired()" v-model="model.name"
                                required :placeholder="$translate('enter_name')" trim></b-form-input>
                        </b-col>
                       
                      
                        
                        <b-col cols="12" class="mt-3">
                            <label class="mb-3"><strong>{{ $translate('description') }}</strong>
                            </label>
                            <b-form-textarea id="input-description" v-model="model.description"
                                :placeholder="$translate('enter_description')" rows="3"></b-form-textarea>
                        </b-col>
                     
                        <b-col cols="12" class="mt-3 d-flex gap-2 justify-content-center">
                            <b-button variant="info"  type="submit"  v-if="hasPermissionUpdate" class="btn-fw"
                                :disabled="submitting ? true : false">{{ submitLabel }}
                            </b-button>
                            <!-- <b-button variant="info" v-if="hasPermissionUpdate" type="submit" class="btn-fw"
                            :disabled="submitting ? true : false">{{ submitLabel }}
                        </b-button> -->
                            <!-- <b-button v-if="hasPermissionDelete && !isNew" @click="deletehealth()" class="float-right"
                                variant="delete-button" size="fw">
                                {{ $deleteLabel() }}
                            </b-button> -->
                            <b-button v-if="!isNew" @click="delete_item_type_group()" class="float-right"
                            variant="delete-button" size="fw">
                            {{ $deleteLabel() }}
                        </b-button>
                            <b-button variant="info" :disabled="submitting" class="btn-fw" @click="cancel()">
                                {{ $cancelLabel() }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
        </div>
    </div>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import utilityMixins from '@/mixins/utilityMixins'

export default {
    name: 'Item Type Group',
    mixins: [popupMixins, permissionsMixins, utilityMixins],
    data() {
        return {
            model: {
                id: 0,
                name: '',
                description:''
            },

            updating: false,

            submitting: false,
        }
    },
    computed: {
        componentName() { return this.$translate('item_type_group') },
        submitLabel() {
            if (this.submitting && this.model.id) {
                return this.$translate('updating')
            } else if (this.submitting) {
                return this.$translate('creating')
            } else if (this.model.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
        title() {
            return this.isNew ? this.$translate('create_item_type_group') : this.$translate('item_type_group')
        },
        item_type_group() {
            const item_type_group = { ...this.$store.state.item_type_group.item_type_group }
          
          
            return item_type_group
        },
      
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        isNew() {
            if (this.model.id == 0 || this.model.id == null) {
                return true
            } else {
                return false
            }
        },
    },
    watch: {
        item_type_group: function (val) {
            this.model = val
        },
    },
    methods: {
        cancel() {
            this.$router.push('/ams/item-type-group')
        },

        CreateOrUpdate() {
            this.submitting = true
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$store
                        .dispatch(
                            this.model.id !== 0 ? 'item_type_group/update' : 'item_type_group/create',
                            this.model
                        )
                        .then(() => {
                            if (this.model.id !== 0) {
                                this.$router.push({ name: 'itemTypeGroup' })
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('updated'),
                                        'success',
                                        `${this.componentName} ${this.$translate('update_alert')}`
                                    )
                                })

                            } else {
                                this.$router.push({ name: 'itemTypeGroup' })
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('created'),
                                        'success',
                                        `${this.componentName} ${this.$translate('create_alert')}`
                                    )
                                })
                            }
                        })
                        .catch(error => {
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                            console.log(error)
                        })
                        .finally(() => {
                            this.submitting = false
                        })
                } else {
                    this.submitting = false
                }
            })
        },

        async delete_item_type_group() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/ams/item-type-group',
                deleteRoute: 'item_type_group/delete',
            }
            const notificationFields = {
                type: 'Document Type',
                errorMsg: this.$translate('unable_item_type_group_alert'),
            }
            try {
                const result = await this.deleteItem(notificationFields, model, routes);
                if (result){
                    this.submitting = true;
                    this.$emit('success');
                }
            } catch (error) {
                console.error(error);
                this.doToast(this.$translate('error'), this.$translate('unable_alert'), 'danger');
            } finally {
                this.submitting = false;
            }
        },
    },
    mounted() {
        if (this.$route.params.id !== 0) {
            this.$store.dispatch('item_type_group/fetchById', this.$route.params.id)
        }
       
    },
}
</script>
<style></style>
